var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendarIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.744141,
    y: 2.04626,
    width: 14.5113,
    height: 14.5938,
    rx: 1.6,
    stroke: "currentColor",
    strokeWidth: 1.28
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.744141 6.92352H15.2554V15.0389C15.2554 15.9226 14.5391 16.6389 13.6554 16.6389H2.34414C1.46049 16.6389 0.744141 15.9226 0.744141 15.0389V6.92352Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 1.28
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0254 0.640015V3.28591",
    stroke: "currentColor",
    strokeWidth: 1.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.08789 0.640015V3.28591",
    stroke: "currentColor",
    strokeWidth: 1.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendar-icon.50f6f105663c118471bc0dcad18ab502.svg";
export { ForwardRef as ReactComponent };